import { api } from "jiffy-api";
import EventBus from "common/eventbus";
import Events from "common/events";
import { isReplaceShirtPage } from "common/utils/browser";
import { initApp } from "components/jiffy/jiffy-services-preview/jiffy-services-preview";
import { initApp as initReactApp } from "components/jiffy/react-jiffy-services-preview/jiffy-services-preview";
import initMadeSampleCTA from "components/jiffy/product-details-made-sample-cta/product-details-made-sample-cta";
import { getFormPayload } from "components/jiffy/vue-product-details-dtf/utils";

import "./product-details-header.scss";

const $getSoftnessScoreAll = () => document.querySelectorAll(".js-header-softness-score");
const $getSoftnessScore = $badge => $badge.querySelector(".js-softness-score-number");
const $getSoftnessRating = $badge => $badge.querySelector(".js-softness-score-rating");
const $getCreditBalance = () => document.querySelectorAll(".js-credit-balance");
const $getSampleAddToCartLink = () => document.querySelector(".js-dtf-sample-add-to-cart");
const $getDesignLabCTAButton = () => document.querySelector(".js-design-lab-cta-button");
const $getPDPUploadButton = () => document.querySelector(".js-product-details-upload-button");
const $getColorVariantSelectorActive = () =>
  document.querySelector(".js-color-variant-selector-active");

const updateSoftnessScore = (_, { softness }) => {
  const isHiddenBadges = !Object.keys(softness).length;

  $getSoftnessScoreAll().forEach($badge => {
    $badge.classList.toggle("hidden", isHiddenBadges);

    const softnessScore = $getSoftnessScore($badge);
    const softnessRating = $getSoftnessRating($badge);

    if (!isHiddenBadges && softnessScore && softnessRating) {
      softnessScore.textContent = softness.score;
      softnessRating.style.width = `${softness.percentage}%`;
    }
  });
};

const updateCreditsAvailable = ({ target }) => {
  const totalAmount = Number(target?.userStoreCredits?.transfers?.totalAmount || 0);
  const formattedTotalAmount = totalAmount.toFixed(2);

  const $creditBalances = $getCreditBalance();

  if ($creditBalances.length === 0 || totalAmount === 0) return;

  $creditBalances.forEach($balance => {
    if (!$balance) return;

    $balance.classList.remove("hidden");

    const $amount = $balance.querySelector(".js-credit-balance-amount");
    if ($amount) {
      $amount.textContent = `$${formattedTotalAmount}`;
    }
  });
};

const addSampleToCart = () => {
  const { variantId } = $getSampleAddToCartLink().dataset;
  if (!variantId) return;

  const payload = {
    ...getFormPayload(),
    sample_pack: true,
    artworks: [
      {
        artwork_id: 0,
        width: 1,
        height: 1,
        quantity: 1,
        variant_id: variantId,
        sample_pack: true
      }
    ]
  };

  api.dtf.addToCart(payload).then(_res => {
    window.location = "/cart";
  });
};

const updateCTAButtonState = (_, eventData) => {
  const ctaButton = $getDesignLabCTAButton();
  const pdpUploadButton = $getPDPUploadButton();

  if (!ctaButton && !pdpUploadButton) return;

  let isOutOfStock = false;

  if (eventData?.compositionId) {
    const colorElement = document.querySelector(
      `[data-composition-id="${eventData.compositionId}"]`
    );
    isOutOfStock = colorElement?.dataset?.oos === "true";
  } else {
    const activeColorDomNode = document.querySelector(".js-color-variant-selector-active");
    isOutOfStock = activeColorDomNode?.dataset?.oos === "true";
  }

  if (ctaButton) {
    ctaButton.disabled = isOutOfStock;
  }

  if (pdpUploadButton) {
    pdpUploadButton.disabled = isOutOfStock;
  }
};

const designLabActionHandler = () => {
  const ctaButton = $getDesignLabCTAButton();

  if (!ctaButton) {
    return;
  }

  const activeColorDomNode = document.querySelector(".js-color-variant-selector-active");
  const activeColor = activeColorDomNode?.dataset?.color;
  const activeCompositionId = activeColorDomNode?.dataset?.compositionId;
  const catalogId = ctaButton.dataset.catalogNumber;

  window.parent.postMessage(
    {
      type: "designlabmodal:productadded",
      payload: {
        catalogId,
        colorName: activeColor,
        compositionId: activeCompositionId,
        replace: ctaButton.dataset.mode === "replace"
      }
    },
    window.location.origin
  );
};

function designLabCompositionSelected(_, { compositionId }) {
  const ctaButton = $getDesignLabCTAButton();
  if (!ctaButton) return;

  const catalogId = ctaButton.dataset.catalogNumber;

  window.parent.postMessage(
    {
      type: "designlabmodal:compositionselected",
      payload: {
        catalogId,
        compositionId
      }
    },
    window.location.origin
  );
}

// eslint-disable-next-line max-lines-per-function
export default () => {
  if (document.querySelector(".js-upsell-container [data-react]")) {
    initReactApp(".js-upsell-container");
  } else {
    initApp(".js-upsell-container");
  }
  initMadeSampleCTA();

  const ctaButton = $getDesignLabCTAButton();

  if (ctaButton) {
    const catalogId = ctaButton.dataset.catalogNumber;

    window.parent.postMessage(
      {
        type: "designlabmodal:productselected",
        payload: {
          catalogId
        }
      },
      window.location.origin
    );

    if (isReplaceShirtPage()) {
      const buttonText = ctaButton.querySelector(".js-design-lab-cta-button-text");
      if (ctaButton && buttonText) {
        ctaButton.setAttribute("data-mode", "replace");
        buttonText.textContent = "Select Product";
      }
    }
  }

  const colorVariantSelectorActive = $getColorVariantSelectorActive();
  if (colorVariantSelectorActive) {
    designLabCompositionSelected(null, {
      compositionId: colorVariantSelectorActive.dataset.compositionId
    });
  }

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, designLabCompositionSelected);
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, updateSoftnessScore);
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, updateCTAButtonState);
  EventBus.on(Events.PRICING_UPDATED, updateCreditsAvailable);

  updateCTAButtonState();

  $getSampleAddToCartLink()?.addEventListener("click", addSampleToCart);
  $getDesignLabCTAButton()?.addEventListener("click", designLabActionHandler);
};
